import { keyframes } from 'styled-components';

import gameConfig from '../config';
import pageParams from '../pageParams';
import data from '../data/logoData';

const { [pageParams.screenSize]: { x, width } } = data;
const hiddenPosition = -width - (pageParams.offsetLeft + x);

const mobile = keyframes`
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`;

const desktop = keyframes`
    0% {
        opacity: 1;
        transform: translateX(0px);
    }
    100% {
        opacity: 0;
        transform: translateX(${hiddenPosition}px);
    }
`;

const hideAnimations = {
    s: {
        name: mobile,
        duration: `${gameConfig.startAnimationDuration}ms`,
        timingFunction: 'ease-in-out',
    },
    m: {
        name: mobile,
        duration: `${gameConfig.startAnimationDuration}ms`,
        timingFunction: 'ease-in-out',
    },
    l: {
        name: desktop,
        duration: `${gameConfig.startAnimationDuration}ms`,
        timingFunction: 'linear',
    },
    xl: {
        name: desktop,
        duration: `${gameConfig.startAnimationDuration}ms`,
        timingFunction: 'linear',
    },
};

function getHideAnimation() {
    return hideAnimations[pageParams.screenSize];
}

export { hiddenPosition };
export default getHideAnimation;
